export const environment = {
    production: true,
    apiUrl: 'https://4o3be5yoc1.execute-api.eu-west-1.amazonaws.com/prod/',
    employeeApiUrl: 'https://4as7o5qfll.execute-api.eu-west-1.amazonaws.com/prod/',
    clientUrl: 'https://s3-eu-west-1.amazonaws.com/www.schiltz-buderscheid.lu/',
    facebookAppId: '588654791519728',
    recaptchaKey: '6Le9ndgUAAAAAIaCXgaxRNetDz6t7OZHHjLYLcAW'
};



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/environments/environment.ts